import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ReviewFilter } from "@/types/chat";

export const useUrlFilter = (userId?: string, jobAdId?: string) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [reviewFilter, setReviewFilter] = useState<ReviewFilter>(
    getFilterFromParams(searchParams, userId)
  );

  const handleReviewFilterChange = (newFilter: ReviewFilter) => {
    setReviewFilter(newFilter);

    if (userId && newFilter !== "all") {
      navigate(`/chat/${jobAdId}`, { replace: true });

      const newParams = new URLSearchParams();
      newParams.set("review_status", newFilter);
      navigate(`/chat/${jobAdId}?${newParams.toString()}`, {
        replace: true,
      });
    } else {
      const newSearchParams = new URLSearchParams(searchParams);
      if (newFilter !== "all") {
        newSearchParams.set("review_status", newFilter);
      } else {
        newSearchParams.delete("review_status");
      }
      const newURL = `${location.pathname}?${newSearchParams.toString()}`;
      navigate(newURL, { replace: true });
    }
  };

  useEffect(() => {
    const filterValue = getFilterFromParams(searchParams, userId);
    setReviewFilter(filterValue);
    if (userId && searchParams.has("review_status")) {
      const newSearchParams = new URLSearchParams(searchParams);
      newSearchParams.delete("review_status");
      const newURL = `${location.pathname}?${newSearchParams.toString()}`;
      navigate(newURL, { replace: true });
    }
  }, [searchParams, userId]);

  return { reviewFilter, setReviewFilter: handleReviewFilterChange };
};

const shouldApplyFilter = (userId?: string) => !userId;

const getFilterFromParams = (searchParams: URLSearchParams, userId?: string) =>
  shouldApplyFilter(userId)
    ? (searchParams.get("review_status") as ReviewFilter) || "all"
    : "all";
